/**
 * @desc 添加托盘
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/inPlate/add`, {
      method: "GET",

      ...options,
    }),
  );
}
